<template>
  <f7-page no-toolbar no-swipeback>
    <f7-navbar title="QUÊN MẬT KHẨU" backLink="Trở lại"></f7-navbar>
    <p class="text-align-center">
      <img :src="require('@/assets/logo.png')" alt="Logo" class="logo">
    </p>
    <f7-list form inset class="mb-2">
      <f7-list-input
          type="text"
          placeholder="Tài khoản"
          :disabled="current_step === 2"
          :value="form_forgot.username"
          @input="form_forgot.username = $event.target.value"
      >
        <f7-icon ios="f7:person" slot="media"></f7-icon>
      </f7-list-input>
    </f7-list>
    <f7-list form inset class="mb-2" v-if="current_step === 2">
      <f7-list-input
          type="select"
          placeholder="Câu hỏi bảo mật 1"
          :value="form_forgot.secret_question_1"
          @input="form_forgot.secret_question_1 = $event.target.value"
      >
        <f7-icon ios="f7:question_square" slot="media"></f7-icon>
        <option :value="item" v-for="(item, idx) in questions" :key="idx">{{ item }}</option>
      </f7-list-input>
      <f7-list-input
          type="text"
          placeholder="Trả lời"
          :value="form_forgot.answer_secret_question_1"
          @input="form_forgot.answer_secret_question_1 = $event.target.value"
      >
        <f7-icon ios="f7:quote_bubble" slot="media"></f7-icon>
      </f7-list-input>
      <f7-list-input
          type="select"
          placeholder="Câu hỏi bảo mật 1"
          :value="form_forgot.secret_question_2"
          @input="form_forgot.secret_question_2 = $event.target.value"
      >
        <f7-icon ios="f7:question_square" slot="media"></f7-icon>
        <option :value="item" v-for="(item, idx) in questions" :key="idx">{{ item }}</option>
      </f7-list-input>
      <f7-list-input
          type="text"
          placeholder="Trả lời"
          :value="form_forgot.answer_secret_question_2"
          @input="form_forgot.answer_secret_question_2 = $event.target.value"
      >
        <f7-icon ios="f7:quote_bubble" slot="media"></f7-icon>
      </f7-list-input>
    </f7-list>
    <f7-block inset class="mt-1">
      <f7-button fill color="primary" @click.prevent="submitForgot">XÁC NHẬN</f7-button>
    </f7-block>
  </f7-page>
</template>
<script>

export default {
  data(){
    return {
      questions  :[
        'Biệt danh lúc nhỏ của bạn',
        'Tên đội thể thao yêu thích của bạn',
        '6 số cuối trong CMND/Passport',
        'Tên chú chó đầu tiên bạn nuôi',
        'Tên trường tiểu học mà bạn đã học',
        'Bạn thân của bạn thời thiếu niên',
        'Món ăn mà bạn thích nhất',
        'Bài hát yêu thích của bạn'
      ],
      form_forgot:{
        username                :'',
        secret_question_1       :'',
        answer_secret_question_1:'',
        secret_question_2       :'',
        answer_secret_question_2:''
      },
      current_step: 1
    };
  },
  methods:{
    submitForgot(){
      if(this.current_step === 1){
        this.getQuestions();
      } else if(this.current_step === 2){
        const app = this.$f7;
        let new_password = '';
        app.dialog.preloader();

        this.$store.dispatch('forgotPassword', this.form_forgot)
            .then((data) => {
              new_password = data.password;
              return this.$store.dispatch('login', {
                username:this.form_forgot.username,
                password:data.password
              })
            })
            .then(() => {
              app.dialog.close();
              this.$f7router.navigate(`/doi-mat-khau-bat-buoc`, {
                props:{
                  old_password:new_password
                }
              });
            })
            .catch((err) => {
              app.dialog.close();
              app.dialog.alert(err, 'LỖI!');
            });
      } else {
        this.$f7.dialog.alert('ERROR', 'ERROR');
      }
    },
    getQuestions(){
      this.$f7.dialog.preloader();

      this.$store.dispatch('getQuestions', this.form_forgot)
          .then((data) => {
            this.$f7.dialog.close();
            this.form_forgot.secret_question_1 = data.data.message.secret_question_1;
            this.form_forgot.secret_question_2 = data.data.message.secret_question_2;

            this.current_step = 2;
          })
          .catch((err) => {
            this.$f7.dialog.close();
            this.$f7.dialog.alert(err, 'LỖI!');
          });
    }
  },
};
</script>
<style scoped>
img.logo {
  height : 70px;
}
</style>
